<template>
  <!-- Contenido del diálogo de ayuda del visor (se carga dentro de EpcModalWrapper).
       Atajos de teclado reales + leyenda de herramientas. Textos en español como el
       resto del visor; se pasarán a i18n más adelante. -->
  <div class="epc-help-dialog">
    <p class="epc-help-intro">Atajos y herramientas del visor de diseño del parque fotovoltaico.</p>

    <div class="epc-help-grid">
      <section class="epc-help-island">
        <h4 class="epc-help-island-title">Atajos de teclado</h4>
        <div class="epc-help-rows">
          <div class="epc-help-row" v-for="(s, i) in shortcuts" :key="'sc_' + i">
            <span class="epc-help-desc">{{ s.desc }}</span>
            <span class="epc-help-keys">
              <kbd class="epc-help-kbd" v-for="(k, j) in s.keys" :key="'k_' + i + '_' + j">{{ k }}</kbd>
            </span>
          </div>
        </div>
      </section>

      <section class="epc-help-island">
        <h4 class="epc-help-island-title">Herramientas y vista</h4>
        <div class="epc-help-rows">
          <div class="epc-help-row epc-help-row--tool" v-for="(t, i) in tools" :key="'tl_' + i">
            <span class="epc-help-tool-icon">
              <b-icon :icon="t.icon" pack="fas" size="is-small"></b-icon>
            </span>
            <span class="epc-help-desc">{{ t.desc }}</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerHelpDialog",

  data() {
    return {
      shortcuts: [
        { desc: 'Mover elemento seleccionado', keys: ['↑', '↓', '←', '→'] },
        { desc: 'Mover 10 px', keys: ['Shift', '↑↓←→'] },
        { desc: 'Cancelar dibujo', keys: ['Esc'] },
        { desc: 'Deshacer último punto (dibujando)', keys: ['Ctrl', 'Z'] },
        { desc: 'Confirmar texto', keys: ['Enter'] },
        { desc: 'Nueva línea en texto', keys: ['Shift', 'Enter'] },
      ],
      tools: [
        { icon: 'lock', desc: 'Candado: alternar navegar (pan) / editar' },
        { icon: 'hand-paper', desc: 'Mano: mover el lienzo' },
        { icon: 'arrows-to-circle', desc: 'Ajustar la vista al contenido' },
        { icon: 'magnifying-glass-plus', desc: 'Zoom: −  ·  % (ajustar)  ·  +' },
        { icon: 'object-ungroup', desc: 'Modo diseño' },
        { icon: 'pen-nib', desc: 'Dibujar vector (áreas)' },
        { icon: 'font', desc: 'Insertar texto' },
        { icon: 'camera', desc: 'Capturar imagen del diseño' },
      ],
    }
  },
}
</script>

<style scoped>
.epc-help-dialog {
  color: #343a40;
}

.epc-help-intro {
  font-size: 13px;
  color: #868e96;
  margin-bottom: 16px;
}

.epc-help-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.epc-help-island {
  background-color: #f7f7fb;
  border: 1px solid #ececf1;
  border-radius: 10px;
  padding: 12px 14px;
}

.epc-help-island-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6965db;
  margin-bottom: 10px;
}

.epc-help-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.epc-help-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}

.epc-help-row--tool {
  justify-content: flex-start;
  gap: 10px;
}

.epc-help-desc {
  color: #343a40;
}

.epc-help-keys {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.epc-help-kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  background-color: #ffffff;
  border: 1px solid #dcdce4;
  border-bottom-width: 2px;
  border-radius: 5px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  color: #495057;
}

.epc-help-tool-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #e3e3e8;
  color: #495057;
  flex-shrink: 0;
}
</style>
